/* YCS Product Page — interactions
   Works alongside Shopify Dawn's built-in variant/form handling. */
(function () {
  document.addEventListener('DOMContentLoaded', function () {

    /* ── Quantity buttons ── */
    document.querySelectorAll('.ycs-qty').forEach(function (q) {
      var input = q.querySelector('input');
      var btns = q.querySelectorAll('button');
      if (!input || btns.length < 2) return;
      btns[0].addEventListener('click', function (e) {
        e.preventDefault();
        var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      btns[1].addEventListener('click', function (e) {
        e.preventDefault();
        var v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* ── Bonus addon toggle (visual only — actual add happens on form submit) ── */
    document.querySelectorAll('.ycs-bonus').forEach(function (b) {
      var checkbox = b.querySelector('input[type="checkbox"]');
      b.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          b.classList.toggle('on', checkbox.checked);
        } else {
          b.classList.toggle('on');
        }
      });
      if (checkbox && checkbox.checked) b.classList.add('on');
    });

    /* ── Bonus add-to-cart on form submit ──
       If the bonus checkbox is ticked when the main "Add to cart" is clicked,
       also add the bonus variant to the cart using Shopify's cart/add.js API. */
    var productForm = document.getElementById('ycs-product-form');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        var bonus = document.querySelector('.ycs-bonus');
        if (!bonus || !bonus.classList.contains('on')) return; // no bonus selected
        var bonusVariantId = bonus.getAttribute('data-bonus-variant-id');
        if (!bonusVariantId) return;

        // Intercept the form, add bonus first, then submit the form normally
        e.preventDefault();
        var submitBtn = productForm.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(bonusVariantId, 10), quantity: 1 })
        })
        .catch(function () { /* even if bonus fails, still add main product */ })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
          productForm.submit(); // submit the main form normally now
        });
      });
    }

    /* ── Gallery: thumbnails switch the active media slide (image or video) ── */
    var galleryMainEl = document.querySelector('.ycs-gallery-main');
    var mediaSlides = galleryMainEl ? galleryMainEl.querySelectorAll('.ycs-media-slide') : [];
    var galleryShots = document.querySelectorAll('.ycs-gallery-stack .ycs-shot');

    /* Play a video / external video inline as soon as its thumbnail is picked.
       Muted is required — every browser blocks autoplay with sound. */
    function ycsPlayInline(slide, type) {
      if (type === 'video') {
        var vid = slide.querySelector('video');
        if (!vid) return;
        vid.muted = true;
        vid.setAttribute('playsinline', '');
        var p = vid.play();
        if (p && p.catch) p.catch(function () {});
      } else if (type === 'external_video') {
        var frame = slide.querySelector('iframe');
        if (!frame) return;
        if (!frame.dataset.ycsSrc) frame.dataset.ycsSrc = frame.src;
        var base = frame.dataset.ycsSrc;
        frame.src = base + (base.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1&mute=1';
      }
    }

    function ycsActivateMedia(id, skipPlay) {
      mediaSlides.forEach(function (slide) {
        var on = slide.getAttribute('data-media-id') === id;
        slide.classList.toggle('is-active', on);
        var type = slide.getAttribute('data-media-type') || 'image';
        if (!on) {
          var vid = slide.querySelector('video');
          if (vid) { try { vid.pause(); } catch (e) {} }
          // Stop a YouTube / Vimeo embed from playing in the background
          var frame = slide.querySelector('iframe');
          if (frame && frame.dataset.ycsSrc) frame.src = '';
        }
        if (on && galleryMainEl) {
          galleryMainEl.setAttribute('data-active-type', type);
          if (!skipPlay) ycsPlayInline(slide, type);
        }
      });
      galleryShots.forEach(function (shot) {
        shot.classList.toggle('is-active', shot.getAttribute('data-media-id') === id);
      });
    }

    // Expose so the variant selector (in ycs-main-product.liquid) can switch the gallery
    window.ycsActivateMedia = ycsActivateMedia;

    galleryShots.forEach(function (s) {
      s.addEventListener('click', function () {
        var id = s.getAttribute('data-media-id');
        if (!id) return;
        ycsActivateMedia(id);
        openLightbox(ycsIndexOfMediaId(id));
      });
    });

    /* ── Lightbox ──
       Clicking ANY media — a thumbnail in the stack or the main frame —
       opens a full-screen viewer at that item. Arrow buttons and the ← →
       keys move between all product media. Esc, the ✕ button or a click on
       the backdrop closes it. Images, videos, external videos and 3D
       models are all supported. */
    var galleryMain = document.querySelector('.ycs-gallery-main');
    var magnify = document.querySelector('.ycs-magnify');
    var slidesArr = Array.prototype.slice.call(mediaSlides);
    var lightbox = null;
    var lightboxIndex = 0;

    function ycsIndexOfMediaId(id) {
      for (var i = 0; i < slidesArr.length; i++) {
        if (slidesArr[i].getAttribute('data-media-id') === id) return i;
      }
      return 0;
    }
    function ycsActiveIndex() {
      for (var i = 0; i < slidesArr.length; i++) {
        if (slidesArr[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    /* Build the element shown inside the lightbox for a given slide. */
    function ycsLightboxNode(slide) {
      var type = slide.getAttribute('data-media-type') || 'image';

      if (type === 'image') {
        var src0 = slide.querySelector('img');
        if (!src0) return null;
        var big = document.createElement('img');
        big.src = (src0.currentSrc || src0.src).replace(/([?&]width=)\d+/, '$1' + 1600);
        big.alt = src0.alt || '';
        big.className = 'ycs-lb-media';
        return big;
      }
      if (type === 'video') {
        var v0 = slide.querySelector('video');
        if (!v0) return null;
        var v = v0.cloneNode(true);
        v.className = 'ycs-lb-media';
        v.setAttribute('controls', '');
        v.setAttribute('playsinline', '');
        v.muted = true;
        v.autoplay = true;
        return v;
      }
      if (type === 'external_video') {
        var f0 = slide.querySelector('iframe');
        if (!f0) return null;
        var f = document.createElement('iframe');
        var base = f0.dataset.ycsSrc || f0.src;
        f.src = base + (base.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1&mute=1';
        f.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        f.className = 'ycs-lb-media ycs-lb-media--frame';
        return f;
      }
      if (type === 'model') {
        var m0 = slide.querySelector('model-viewer');
        if (!m0) return null;
        var m = m0.cloneNode(true);
        m.className = 'ycs-lb-media ycs-lb-media--frame';
        m.setAttribute('camera-controls', '');
        return m;
      }
      return null;
    }

    function ycsRenderLightbox() {
      if (!lightbox) return;
      var stage = lightbox.querySelector('.ycs-lb-stage');
      var counter = lightbox.querySelector('.ycs-lb-counter');
      stage.innerHTML = '';
      var node = ycsLightboxNode(slidesArr[lightboxIndex]);
      if (node) stage.appendChild(node);
      if (counter) counter.textContent = (lightboxIndex + 1) + ' / ' + slidesArr.length;
      // Keep the page gallery in sync, but don't start the inline video behind the overlay
      var id = slidesArr[lightboxIndex].getAttribute('data-media-id');
      if (id) ycsActivateMedia(id, true);
    }

    function ycsLightboxStep(delta) {
      if (!slidesArr.length) return;
      lightboxIndex = (lightboxIndex + delta + slidesArr.length) % slidesArr.length;
      ycsRenderLightbox();
    }

    function onLightboxKey(e) {
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') ycsLightboxStep(-1);
      else if (e.key === 'ArrowRight') ycsLightboxStep(1);
    }

    function closeLightbox() {
      if (!lightbox) return;
      document.removeEventListener('keydown', onLightboxKey);
      document.body.style.overflow = '';
      lightbox.remove();
      lightbox = null;
    }

    function openLightbox(index) {
      if (lightbox || !slidesArr.length) return;
      lightboxIndex = typeof index === 'number' ? index : ycsActiveIndex();

      lightbox = document.createElement('div');
      lightbox.className = 'ycs-lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.innerHTML =
        '<button type="button" class="ycs-lb-close" aria-label="Close">&times;</button>' +
        '<button type="button" class="ycs-lb-nav ycs-lb-prev" aria-label="Previous">&#8249;</button>' +
        '<div class="ycs-lb-stage"></div>' +
        '<button type="button" class="ycs-lb-nav ycs-lb-next" aria-label="Next">&#8250;</button>' +
        '<span class="ycs-lb-counter"></span>';

      if (slidesArr.length < 2) {
        lightbox.querySelector('.ycs-lb-prev').style.display = 'none';
        lightbox.querySelector('.ycs-lb-next').style.display = 'none';
        lightbox.querySelector('.ycs-lb-counter').style.display = 'none';
      }

      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.classList.contains('ycs-lb-stage')) closeLightbox();
      });
      lightbox.querySelector('.ycs-lb-close').addEventListener('click', closeLightbox);
      lightbox.querySelector('.ycs-lb-prev').addEventListener('click', function (e) {
        e.stopPropagation(); ycsLightboxStep(-1);
      });
      lightbox.querySelector('.ycs-lb-next').addEventListener('click', function (e) {
        e.stopPropagation(); ycsLightboxStep(1);
      });

      document.body.appendChild(lightbox);
      document.body.style.overflow = 'hidden';
      ycsRenderLightbox();
      requestAnimationFrame(function () { lightbox.classList.add('is-open'); });
      document.addEventListener('keydown', onLightboxKey);
      lightbox.querySelector('.ycs-lb-close').focus();
    }

    if (magnify) {
      magnify.removeAttribute('aria-hidden');
      magnify.setAttribute('role', 'button');
      magnify.setAttribute('tabindex', '0');
      magnify.setAttribute('aria-label', 'Zoom');
      magnify.style.cursor = 'pointer';
      magnify.addEventListener('click', function (e) {
        e.stopPropagation();
        openLightbox();
      });
      magnify.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(); }
      });
    }
    if (galleryMain) {
      galleryMain.addEventListener('click', function (e) {
        if (e.target.closest('.ycs-magnify')) return;
        // Don't hijack clicks on the video / 3D controls, or the player breaks
        if (e.target.closest('video, iframe, model-viewer')) return;
        openLightbox(ycsActiveIndex());
      });
    }

    /* ── Sticky cart: show after user scrolls past the buy box ── */
    var bar = document.querySelector('.ycs-sticky-cart');
    var trigger = document.querySelector('.ycs-pdp-wrap');
    if (bar && trigger) {
      var onScroll = function () {
        var r = trigger.getBoundingClientRect();
        bar.classList.toggle('show', r.top < -120);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();

      /* Forward sticky "Add" click to the real product form button */
      var stickyBtn = bar.querySelector('.ycs-btn');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var realBtn = document.querySelector('.ycs-buy [type="submit"].ycs-btn-ink');
          if (realBtn) realBtn.click();
        });
      }
    }

  });
})();
